import { Head } from "@aviv-unified-frontend/runtime/head";

import {
  DEPLOYMENT_FOOTPRINT,
  ENVIRONMENT,
  VERSION,
} from "../../constants/environment";
import { BRAND_CONFIGURATION } from "../../../configs/brands";

export const MetaDatas = () => {
  return (
    <Head>
      <title>{BRAND_CONFIGURATION.defaultTitle}</title>
      <meta
        name="description"
        content={BRAND_CONFIGURATION.defaultDescription}
      />
      <meta
        name="version:shell"
        content={VERSION}
      />
      <meta
        name="deployment:environment"
        content={ENVIRONMENT}
      />
      {DEPLOYMENT_FOOTPRINT && (
        <meta
          name="deployment:footprint"
          content={DEPLOYMENT_FOOTPRINT}
        />
      )}
    </Head>
  );
};
